<template>
	<div style="user-select: none" :style="refreshable ? { cursor: 'pointer' } : {}" @click="refreshable && refresh()">
		<canvas ref="canvas" id="id-canvas" :width="contentWidth" :height="contentHeight"></canvas>
	</div>
</template>

<script>
	const codeTypeMap = {
		A: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
		a: "abcdefghijklmnopqrstuvwxyz",
		0: "0123456789",
	}

	export default {
		name: 'CaptchaImage',

		props: {
			codeLength: {
				type: Number,
				default: 4,
			},
			codeType: {
				type: Array,
				default: () => ["A", "a", "0"],
			},
			/**
			 * 容器寬度
			 */
			contentWidth: {
				type: Number,
				default: 120,
			},
			/**
			 * 容器高度
			 */
			contentHeight: {
				type: Number,
				default: 40,
			},
			/**
			 * 字型最小值
			 */
			fontSizeMin: {
				type: Number,
				default: 24,
			},
			/**
			 * 字型最大值
			 */
			fontSizeMax: {
				type: Number,
				default: 36,
			},
			/**
			 * 文字顏色最小值
			 */
			textColorMin: {
				type: Number,
				default: 50,
			},
			/**
			 * 文字顏色最大值
			 */
			textColorMax: {
				type: Number,
				default: 160,
			},
			/**
			 * 文字旋轉最小值
			 */
			textDegMin: {
				type: Number,
				default: -30,
			},
			/**
			 * 文字旋轉最大值
			 */
			textDegMax: {
				type: Number,
				default: 30,
			},
			/**
			 * 圖片背景色最小值
			 */
			backgroundColorMin: {
				type: Number,
				default: 200,
			},
			/**
			 * 圖片背景色最大值
			 */
			backgroundColorMax: {
				type: Number,
				default: 220,
			},
			/**
			 * 干擾點數量
			 */
			dotCount: {
				type: Number,
				default: 30,
			},
			/**
			 * 干擾點顏色最小值
			 */
			dotColorMin: {
				type: Number,
				default: 0,
			},
			/**
			 * 干擾點顏色最大值
			 */
			dotColorMax: {
				type: Number,
				default: 255,
			},
			/**
			 * 干擾線數量
			 */
			lineCount: {
				type: Number,
				default: 4,
			},
			/**
			 * 干擾線顏色最小值
			 */
			lineColorMin: {
				type: Number,
				default: 40,
			},
			/**
			 * 干擾線顏色最大值
			 */
			lineColorMax: {
				type: Number,
				default: 180,
			},
			/**
			 * 點擊是否重整
			 */
			refreshable: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				verifyCode: '0000'
			}
		},
		computed: {
			codeRandomList() {
				return this.codeType.map((it) => codeTypeMap[it]).join("")
			}
		},
		mounted() {
			this.drawPic()
		},
		methods: {
			randomNum(min, max) {
				return Math.floor(Math.random() * (max - min) + min)
			},
			randomColor(min, max) {
				let r = this.randomNum(min, max)
				let g = this.randomNum(min, max)
				let b = this.randomNum(min, max)
				return `rgb(${r},${g},${b})`
			},
			randomCode() {
				let code = ""
				for (let i = 0; i < this.codeLength; i++) {
					const i = this.randomNum(0, this.codeRandomList.length)
					code += this.codeRandomList[i]
				}
				this.verifyCode = code
			},
			drawText(ctx, txt, i) {
				ctx.fillStyle = this.randomColor(this.textColorMin, this.textColorMax)
				ctx.font = "bold " + this.randomNum(this.fontSizeMin, this.fontSizeMax) + "px Arial"

				const x = i * ((this.contentWidth - 15) / this.codeLength) + 10
				const y = this.randomNum(this.fontSizeMax, this.contentHeight)
				const deg = this.randomNum(this.textDegMin, this.textDegMax)

				ctx.translate(x, y)
				ctx.rotate((deg * Math.PI) / 180)

				ctx.fillText(txt, 0, 0)

				ctx.rotate((-deg * Math.PI) / 180)
				ctx.translate(-x, -y)
			},
			drawLine(ctx) {
				// 繪製干擾線
				for (let i = 0; i < this.lineCount; i++) {
					ctx.strokeStyle = this.randomColor(this.lineColorMin, this.lineColorMax)
					ctx.beginPath()
					ctx.moveTo(
						this.randomNum(0, this.contentWidth),
						this.randomNum(0, this.contentHeight)
					)
					ctx.lineTo(
						this.randomNum(0, this.contentWidth),
						this.randomNum(0, this.contentHeight)
					)
					ctx.stroke()
				}
			},
			drawDot(ctx) {
				// 繪製干擾點
				for (let i = 0; i < this.dotCount; i++) {
					ctx.fillStyle = this.randomColor(this.dotColorMin, this.dotColorMax)
					ctx.beginPath()
					ctx.arc(
						this.randomNum(0, this.contentWidth),
						this.randomNum(0, this.contentHeight),
						1,
						0,
						2 * Math.PI
					)
					ctx.fill()
				}
			},
			drawPic() {
				this.randomCode()
				let canvas = this.$refs.canvas
				let ctx = canvas.getContext("2d")
				ctx.textBaseline = "bottom"
				ctx.fillStyle = this.randomColor(
					this.backgroundColorMin,
					this.backgroundColorMax
				)
				ctx.fillRect(0, 0, this.contentWidth, this.contentHeight)

				for (let i = 0; i < this.codeLength; i++) {
					this.drawText(ctx, this.verifyCode[i], i)
				}
				this.drawLine(ctx)
				this.drawDot(ctx)
			},
			refresh() {
				this.drawPic()
			},
			verify(input, ignoreCase = false) {
				if (ignoreCase) {
					return input.toLowerCase() === this.verifyCode.toLowerCase()
				}
				return input === this.verifyCode
			}

		}
	}

</script>
